/* eslint-disable */
export const closeIcon = {
  data: `<svg viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.00537 1.50195L15.9999 16.4964Z" fill="currentColor"/><path d="M15.9999 1.50195L1.00537 16.4964Z" fill="currentColor"/><path d="M1.00537 1.50195L15.9999 16.4964M15.9999 1.50195L1.00537 16.4964" stroke="currentColor" stroke-width="1.87431" stroke-linecap="round"/></svg>`,
  name: 'close' as const,
};
